import {Component, Input, OnInit} from '@angular/core';
import {MeasurementInputModel} from '../../../../../models/questions/subModels/measurementInput.model';
import {QuestionModel} from '../../../../../models/questions/question.model';
import {ImageCategoryTypes} from '../../../../../models/questions/shared/imageType.model';
import {DropdownModel} from '../../../../../models/component/dropdown.model';
import {EvoImageSelectorService} from '../../../../../shared/list-views/evo-image-selector/evo-image-selector.service';
import {Enums} from '../../../../../models/extensions/enums';

@Component({
  selector: 'app-evo-measurement-input',
  templateUrl: './evo-measurement-input.component.html',
  styleUrls: ['./evo-measurement-input.component.css']
})
export class EvoMeasurementInputComponent implements OnInit {

  Enums = Enums;
  @Input() question: QuestionModel = new MeasurementInputModel();
  QuestionModel = QuestionModel;

  ImageCategoryTypes = ImageCategoryTypes;

  constructor(private imageSelectorSv: EvoImageSelectorService) { }

  ngOnInit() {
  }

  castQuestion(): MeasurementInputModel {

    return <MeasurementInputModel>this.question;
  }

  showQuestion(): boolean {

    if (this.question) {
      if (this.question.subCategory === Enums.QuestionSubcategories.measurementInput) {
        return true;
      }
    }

    return false;
  }

  getMetricTypeList(): DropdownModel[] {

    if (this.castQuestion().model.metricType === Enums.Metrics.length) {
      return [DropdownModel.generateFromKey(Enums.MetricLengths.cm)];
    }

    return [DropdownModel.generateFromKey(Enums.MetricWeights.gr)];

  }

  getUSCustomaryTypeList(): DropdownModel[] {

    if (this.castQuestion().model.metricType === Enums.Metrics.length) {
      return [DropdownModel.generateFromKey(Enums.USCustomaryLengths.in)];
    }

    return [DropdownModel.generateFromKey(Enums.USCustomaryWeights.oz)];

  }

  addMetricItem() {

    const imagesToExclude = [];

    for (let i = 0; i < this.castQuestion().model.metricSystem.list.length; i++) {
      imagesToExclude.push(this.castQuestion().model.metricSystem.list[i].image);
    }

    this.imageSelectorSv.show(this.castQuestion().model.imageCategory, imagesToExclude).subscribe((image) => {

      if (image) {
        this.castQuestion().model.metricSystem.list.push({
          image: image,
          value: 0
        });
      }

    });
  }

  removeMetricItem(index: number) {
    this.castQuestion().model.metricSystem.list.splice(index, 1);
  }

  addUSCustomaryItem() {

    const imagesToExclude = [];

    for (let i = 0; i < this.castQuestion().model.usCustomarySystem.list.length; i++) {
      imagesToExclude.push(this.castQuestion().model.usCustomarySystem.list[i].image);
    }

    this.imageSelectorSv.show(this.castQuestion().model.imageCategory, imagesToExclude).subscribe((image) => {
      if (image) {
        this.castQuestion().model.usCustomarySystem.list.push({
          image: image,
          value: 0
        });
      }
    });

  }

  removeUSMetricItem(index: number) {
    this.castQuestion().model.usCustomarySystem.list.splice(index, 1);
  }

  questionStringMetric(): string {

    return this.questionStringGeneration(this.castQuestion().model.metricSystem.list) + ' ' + this.castQuestion().model.metricSystem.baseUnit;

  }

  questionStringUSCustomary(): string {

    return this.questionStringGeneration(this.castQuestion().model.usCustomarySystem.list) + ' ' + this.castQuestion().model.usCustomarySystem.baseUnit;

  }

  questionStringGeneration(list: { value: number, image: string }[]): string {

    let questionString = '[';

    for (let i = 0; i < list.length; i++) {

      const measurementElement = list[i];
      questionString += `${measurementElement.value}`;

      if (i !== list.length - 1) {
        questionString += `, `;
      }

    }

    questionString += ']';

    return questionString;

  }


}
